<template>
  <Teleport to="body">
    <div v-if="isModalOpen" class="modal-overlay" @click.self="$emit('closeModal')">
      <div class="modal-content" :style="{ maxWidth }">
        <a
          class="modal-hide"
          :class="withoutCloseOption ? 'display-none' : 'display-initial'"
          @click="$emit('closeModal')"
        >
          ✕
        </a>
        <h2 class="m-4 modal-title">{{ title }}</h2>
        <section class="m-4 modal-body">
          <slot name="content"></slot>
        </section>
        <section v-if="withActions" class="m-5 modal-actions">
          <slot name="actions"></slot>
        </section>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  title: { type: String, default: '' },
  showModal: { type: Boolean, required: true },
  maxWidth: { type: String, default: '400px' },
  withoutCloseOption: { type: Boolean, default: false },
  withActions: { type: Boolean, default: false },
});

const emits = defineEmits(['closeModal']);

const isModalOpen = ref(props.showModal);

watch(
  () => props.showModal,
  (newVal) => {
    isModalOpen.value = newVal;
  }
);
</script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fade-in 0.3s ease-out;
}

.modal-content {
  background: #fff;
  padding: 1.5rem;
  border-radius: 0.5rem;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  max-height: 95dvh;
  overflow-y: auto;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  text-align: center;
}

.modal-body {
  margin: 1rem 0;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.modal-hide {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  font-size: 18px;
  color: #333;
  cursor: pointer;
}

.display-none {
  display: none;
}

.display-initial {
  display: initial;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
